/**
 * A page's icon (ADR-0087): an emoji or a few characters, or an image from the workspace's files
 * (stored as `file:<id>`), shown at the size of the text around it.
 */
export function PageIcon(props: { icon: string | null | undefined }) {
  const icon = props.icon;
  if (!icon) return null;
  if (icon.startsWith("file:")) {
    return (
      <img
        className="page-icon-image"
        src={`/api/files/${encodeURIComponent(icon.slice(5))}`}
        alt=""
        loading="lazy"
        decoding="async"
      />
    );
  }
  return <>{icon}</>;
}
